import { Company } from "./company-interfaces";
import { Membership } from "./payment-interfaces";

export interface User {
    id: string;
    password: string | null;
    email: string;
    is_active: boolean;
    is_superuser: boolean;
    is_verified: boolean;
    first_name: string;
    last_name: string;
    role: string;
    deleted_at: string | null;
    settings?: UserSettings | null;
    company?: Company | null;
    membership?: Membership | null;
}

export interface UserSettings {
    id: string;
    ui_language: string;
    ui_theme: 'light' | 'dark' | string;
    subscribe_to_updates: boolean;
    feedback_hear_about?: string | undefined;
    workspace_preferences?: string[] | undefined;
    enable_2fa: boolean;
    image_url: string | null;
    accepted_terms: boolean;
}

export interface InviteUserResponse {
    id: string;
    invite_url: string;
    email: string;
    assigned_role: string;
    invited_by_user: User;
    assigned_to_company: Company;
    valid_to: string;
}

export enum UiLanguage {
    EN = "EN",
    IT = "IT"
}

export interface PasswordValidator {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    number: boolean;
    special: boolean;
}